// removed by extract-text-webpack-plugin
module.exports = {"deleteBtn":"index__deleteBtn___b8yiJ","saveBtn":"index__saveBtn___2bbFC","saveAndNewBtn":"index__saveAndNewBtn___3KwxU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/page/TaskDetails/components/Actions/index.less
// module id = 1940
// module chunks = 3